import React, { lazy } from 'react';

const AffiliateContainer = lazy(() => import('../../containers/affiliate/affiliateContainer'));
const AccountSettingsContainer = lazy(() => import('../../containers/affiliate/accountSettingsContainer'));

export const AFFILIATE_ROUTES = [
  {
    path: '/affiliate',
    component: <AffiliateContainer />,
    group: 'Affiliate',
    reducer: 'affiliate',
  },
  {
    path: '/affiliate/account-settings',
    component: <AccountSettingsContainer />,
    group: 'Affiliate',
    reducer: 'affiliateAccountSettings'
  },
];
